import * as React from 'react';

import { Col, Container, Row } from '@coursera/coursera-ui';

import SurveyMonkeyBanner from 'bundles/career-plans/components/SurveyMonkeyBanner';
import type { CareerPlansPageContentType } from 'bundles/career-plans/components/data/types/career-plans';
import DegreeBanner from 'bundles/career-plans/components/degree/DegreeBanner';
import CareerPlansFaqs from 'bundles/career-plans/components/faq/CareerPlansFaqs';
import CareerPlansHeader from 'bundles/career-plans/components/header/CareerPlansHeader';
import CareerPlansTestimonials from 'bundles/career-plans/components/testimonials/CareerPlansTestimonials';
import CareerPlansTimeline from 'bundles/career-plans/components/timeline/CareerPlansTimeline';
import { CourseraMetatags } from 'bundles/seo';

import 'css!./__styles__/CareerPlansLayout';

type Props = CareerPlansPageContentType;

const CareerPlansLayout: React.LegacyFunctionComponentWithChildren<Props> = ({
  pageName,
  pageDescription,
  socialProofStatistics,
  socialProofStatisticsSource,
  socialProofStatisticsSourceDescription,
  ctaText,
  orderedCareers = [],
  faq,
  degrees,
  seeMoreDegreesUrl,
  testimonials,
  metaTitle,
  metaDescription,
  children,
}) => {
  const roles = orderedCareers.map(({ name, level, skillLevel }) => ({ name, level: level || skillLevel }));
  const computedMetaTitle = metaTitle || `${pageName} Career Learning Path | Coursera`;
  const computedMetaDescription = metaDescription || pageDescription;

  return (
    <section className="rc-CareerPlansLayout styleguide">
      <Container className="careerPlans-header careerPlans-purple-bg">
        <Row>
          <Col>
            <CareerPlansHeader
              pageName={pageName}
              pageDescription={pageDescription}
              socialProofStatistics={socialProofStatistics}
              socialProofStatisticsSource={socialProofStatisticsSource}
              socialProofStatisticsSourceDescription={socialProofStatisticsSourceDescription}
              backgroundImageUrl="https://s3.amazonaws.com/coursera_assets/career_plans/HeaderBG-careerPlans.png"
            />
          </Col>
        </Row>
      </Container>
      <Container className="careerPlans-main">
        <CareerPlansTimeline roles={roles} ctaText={ctaText} />
        <Row>
          <Col className="careerPlans-container">{children}</Col>
        </Row>
      </Container>
      <Container className="careerPlans-secondary">
        <CareerPlansTestimonials testimonials={testimonials} />
        <DegreeBanner degrees={degrees} seeMoreDegreesUrl={seeMoreDegreesUrl} />
        <SurveyMonkeyBanner />
        <CareerPlansFaqs faqs={faq} />
      </Container>
      <CourseraMetatags
        metaNameAndProperties={{
          title: computedMetaTitle,
          description: computedMetaDescription,
          disableCourseraSuffix: true,
        }}
      />
    </section>
  );
};

export default CareerPlansLayout;
